import { observable } from 'mobx'
import {
  RequestConsultationValidate
} from '../validators/RequestConsultationValidate'
import UserValidate from '../validators/UserValidate'
import { LABEL } from '../lang'

export default class {
  @observable first_name = null;
  @observable last_name = null;
  @observable email = null;
  @observable phone = null;

  constructor (first_name = '', last_name = '', email = '', phone, street_address1 = '', street_address2 = '', city = '', state = '', zip = '', industry = '', job_title = '', number_of_employees = '', firm_name = '') {
    this.first_name = new Validator('first_name', LABEL.LBL_USER_FIRST_NAME, first_name)
    this.last_name = new Validator('last_name', LABEL.LBL_USER_LAST_NAME, last_name)
    this.email = new Validator('email', LABEL.LBL_USER_EMAIL, email)
    this.phone = new Validator('phone', LABEL.LBL_USER_PHONE, phone)
    this.street_address1 = new UserValidate('street_address1', LABEL.LBL_USER_ADDR1, '')
    this.street_address2 = new UserValidate('street_address2', LABEL.LBL_USER_ADDR2, '', false)
    this.city = new UserValidate('city', LABEL.LBL_USER_CITY_NAME, '')
    this.state = new UserValidate('state', LABEL.LBL_USER_STATE_NAME, '')
    this.zip = new UserValidate('zip', LABEL.LBL_USER_ZIP, '', true, 5, 6)
    this.industry = new Validator('industry', LABEL.LBL_INDUSTRY, '')
    this.job_title = new Validator('job_title', LABEL.LBL_JOB_TITLE, '')
    this.number_of_employees = new UserValidate('number_of_employees', LABEL.LBL_NUMBER_OF_EMPLOYEES, '')
    this.firm_name = new UserValidate('firm_name', LABEL.LBL_USER_FIRM_NAME, '')
  }

  resetInputs () {
    this.first_name = new Validator('first_name', LABEL.LBL_USER_FIRST_NAME, '')
    this.last_name = new Validator('last_name', LABEL.LBL_USER_LAST_NAME, '')
    this.email = new Validator('email', LABEL.LBL_USER_EMAIL, '')
    this.phone = new Validator('phone', LABEL.LBL_USER_PHONE, '')
    this.street_address1 = new UserValidate('street_address1', LABEL.LBL_USER_ADDR1, '')
    this.street_address2 = new UserValidate('street_address2', LABEL.LBL_USER_ADDR2, '', false)
    this.city = new UserValidate('city', LABEL.LBL_USER_CITY_NAME, '')
    this.state = new UserValidate('state', LABEL.LBL_USER_STATE_NAME, '')
    this.zip = new UserValidate('zip', LABEL.LBL_USER_ZIP, '', 5, 6)
    this.industry = new UserValidate('industry', LABEL.LBL_INDUSTRY, '')
    this.job_title = new UserValidate('job_title', LABEL.LBL_JOB_TITLE, '')
    this.number_of_employees = new UserValidate('number_of_employees', LABEL.LBL_NUMBER_OF_EMPLOYEES, '')
    this.firm_name = new UserValidate('firm_name', LABEL.LBL_USER_FIRM_NAME, '')
  }

  getParams () {
    return {
      'first_name': this.first_name.value.trim(),
      'last_name': this.last_name.value.trim(),
      'email': this.email.value.trim(),
      'phone': this.phone.value.trim(),
      'street_address1': this.street_address1.value.trim(),
      'street_address2': this.street_address2.value.trim(),
      'city': this.city.value.trim(),
      'state': this.state.value.trim(),
      'zip': this.zip.value.trim(),
      'industry': this.industry.value.trim(),
      'job_title': this.job_title.value.trim(),
      'number_of_employees': this.number_of_employees.value.trim(),
      'firm_name': this.number_of_employees.value.trim()

    }
  }

  update (key_name, value) {
    this[key_name].value = value
    // this[key_name].validate()
  }

  validate () {
    let isValid = true
    for (const key in this) {
      this[key].validate()
      if (this[key].errors.length) {
        isValid = false
      }
    }
    return isValid
  }
}
